import type { Theme } from '@mui/material';
import type { StyleExtend } from 'providers/theme/theme.types';

export const FooterWrapperStyle: StyleExtend<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  gap: '.5rem',
};
